import { useState, useEffect } from "react";
import DatePicker from "../board/components/TaskDetail/DatePicker";
import InputInline from "../components/InputInline";
import SelectInline from "../board/components/TaskDetail/SelectInline";
import DropdownField from "../board/components/DropdownField";

type CustomFieldPropsType = {
  field: any;
  isGrid?: boolean;
  onChange: (value: string | Date) => void;
  variant?: "default" | "inline";
};

const CustomField = (props: CustomFieldPropsType) => {
  const { field, isGrid = false, onChange } = props;
  const [valueField, setValueField] = useState<any>();

  useEffect(() => {
    if (field) {
      setValueField(field.value);
    }
  }, [field.value]); // eslint-disable-line react-hooks/exhaustive-deps

  const renderField = () => {
    let component: any;
    switch (field.type) {
      case "datetime":
        component = (
          <DatePicker
            selected={valueField}
            onChange={(value: string) => {
              setValueField(value);
              onChange(value);
            }}
          />
        );
        break;
      case "string":
      case "double":
        component = (
          <InputInline
            value={valueField}
            border={!isGrid}
            variant={props.variant}
            onFinish={(value: string) => {
              setValueField(value);
              onChange(value);
            }}
          />
        );
        break;
      case "boolean":
        component =
          props.variant === "inline" ? (
            <SelectInline
              autoOpen={true}
              options={[
                { value: "yes", label: "Yes" },
                { value: "no", label: "No" },
              ]}
              value={valueField}
              onChange={(value: string) => {
                setValueField(value);
                onChange(value);
              }}
            />
          ) : (
            <DropdownField
              options={[
                { id: "yes", name: "Yes" },
                { id: "no", name: "No" },
              ]}
              value={valueField ?? ""}
              onChange={(id: string) => {
                setValueField(id);
                onChange(id);
              }}
            />
          );
        break;

      default:
        component = null;
        break;
    }
    return component;
  };
  return renderField();
};

export default CustomField;
